export const books = [
	{
		id: 1,
		name: 'Genesis',
		testament: 'OT',
		genre: {
			id: 1,
			name: 'Law',
		},
		abbreviations: ['Gen', 'Gen.', 'Ge', 'Gn'],
	},
	{
		id: 2,
		name: 'Exodus',
		testament: 'OT',
		genre: {
			id: 1,
			name: 'Law',
		},
		abbreviations: ['Exod', 'Exod.', 'Exo', 'Exo.', 'Ex', 'Ex.'],
	},
	{
		id: 3,
		name: 'Leviticus',
		testament: 'OT',
		genre: {
			id: 1,
			name: 'Law',
		},
		abbreviations: ['Lev', 'Lev.', 'Le', 'Lv'],
	},
	{
		id: 4,
		name: 'Numbers',
		testament: 'OT',
		genre: {
			id: 1,
			name: 'Law',
		},
		abbreviations: ['Num', 'Num.', 'Nu', 'Nm', 'Numb', 'Numb.'],
	},
	{
		id: 5,
		name: 'Deuteronomy',
		testament: 'OT',
		genre: {
			id: 1,
			name: 'Law',
		},
		abbreviations: ['Deut', 'Deut.', 'Deu', 'Deu.', 'Dt', 'De'],
	},
	{
		id: 6,
		name: 'Joshua',
		testament: 'OT',
		genre: {
			id: 2,
			name: 'History',
		},
		abbreviations: ['Josh', 'Josh.', 'Jos', 'Jos.'],
	},
	{
		id: 7,
		name: 'Judges',
		testament: 'OT',
		genre: {
			id: 2,
			name: 'History',
		},
		abbreviations: ['Judg', 'Judg.', 'Jdg', 'Jdg.', 'Jdgs', 'Jdgs.'],
	},
	{
		id: 8,
		name: 'Ruth',
		testament: 'OT',
		genre: {
			id: 2,
			name: 'History',
		},
		abbreviations: ['Ru', 'Rth', 'Rut'],
	},
	{
		id: 9,
		name: '1 Samuel',
		testament: 'OT',
		genre: {
			id: 2,
			name: 'History',
		},
		abbreviations: ['1 Sam', '1 Sam.', '1 Sa', '1Sa', '1Sam', 'I Sam', 'I Sam.', 'I Samuel'],
	},
	{
		id: 10,
		name: '2 Samuel',
		testament: 'OT',
		genre: {
			id: 2,
			name: 'History',
		},
		abbreviations: ['2 Sam', '2 Sam.', '2 Sa', '2Sa', '2Sam', 'II Sam', 'II Sam.', 'II Samuel'],
	},
	{
		id: 11,
		name: '1 Kings',
		testament: 'OT',
		genre: {
			id: 2,
			name: 'History',
		},
		abbreviations: ['1 Kgs', '1 Kgs.', '1 Ki', '1Ki', '1Kgs', 'I Kings', 'I Kgs', 'I Kgs.'],
	},
	{
		id: 12,
		name: '2 Kings',
		testament: 'OT',
		genre: {
			id: 2,
			name: 'History',
		},
		abbreviations: ['2 Kgs', '2 Kgs.', '2 Ki', '2Ki', '2Kgs', 'II Kings', 'II Kgs', 'II Kgs.'],
	},
	{
		id: 13,
		name: '1 Chronicles',
		testament: 'OT',
		genre: {
			id: 2,
			name: 'History',
		},
		abbreviations: ['1 Chr', '1 Chr.', '1 Ch', '1Ch', '1Chr', '1 Chron', '1 Chron.', '1Chron', 'I Chronicles', 'I Chr', 'I Chr.', 'I Chron', 'I Chron.'],
	},
	{
		id: 14,
		name: '2 Chronicles',
		testament: 'OT',
		genre: {
			id: 2,
			name: 'History',
		},
		abbreviations: ['2 Chr', '2 Chr.', '2 Ch', '2Ch', '2Chr', '2 Chron', '2 Chron.', '2Chron', 'II Chronicles', 'II Chr', 'II Chr.', 'II Chron', 'II Chron.'],
	},
	{
		id: 15,
		name: 'Ezra',
		testament: 'OT',
		genre: {
			id: 2,
			name: 'History',
		},
		abbreviations: ['Ezr', 'Ezr.'],
	},
	{
		id: 16,
		name: 'Nehemiah',
		testament: 'OT',
		genre: {
			id: 2,
			name: 'History',
		},
		abbreviations: ['Neh', 'Neh.', 'Ne'],
	},
	{
		id: 17,
		name: 'Esther',
		testament: 'OT',
		genre: {
			id: 2,
			name: 'History',
		},
		abbreviations: ['Esth', 'Esth.', 'Est', 'Est.', 'Es'],
	},
	{
		id: 18,
		name: 'Job',
		testament: 'OT',
		genre: {
			id: 3,
			name: 'Wisdom',
		},
		abbreviations: ['Jb'],
	},
	{
		id: 19,
		name: 'Psalm',
		testament: 'OT',
		genre: {
			id: 3,
			name: 'Wisdom',
		},
		abbreviations: ['Psalms', 'Ps', 'Ps.', 'Psa', 'Psa.', 'Pss', 'Pss.', 'Psm', 'Psm.'],
	},
	{
		id: 20,
		name: 'Proverbs',
		testament: 'OT',
		genre: {
			id: 3,
			name: 'Wisdom',
		},
		abbreviations: ['Prov', 'Prov.', 'Pro', 'Pro.', 'Pr', 'Prv', 'Prv.'],
	},
	{
		id: 21,
		name: 'Ecclesiastes',
		testament: 'OT',
		genre: {
			id: 3,
			name: 'Wisdom',
		},
		abbreviations: ['Eccl', 'Eccl.', 'Eccles', 'Eccles.', 'Ecc', 'Ecc.', 'Ec', 'Qoh'],
	},
	{
		id: 22,
		name: 'Song of Solomon',
		testament: 'OT',
		genre: {
			id: 3,
			name: 'Wisdom',
		},
		abbreviations: [
			'Song', 'Song.', 'SOS', 'Sol', 'Sol.', 'Sg',
			'Song of Songs', 'Song of Sol', 'Song of Sol.',
			'SS', 'Cant', 'Cant.',
		],
	},
	{
		id: 23,
		name: 'Isaiah',
		testament: 'OT',
		genre: {
			id: 4,
			name: 'Prophets',
		},
		abbreviations: ['Isa', 'Isa.', 'Is'],
	},
	{
		id: 24,
		name: 'Jeremiah',
		testament: 'OT',
		genre: {
			id: 4,
			name: 'Prophets',
		},
		abbreviations: ['Jer', 'Jer.', 'Je'],
	},
	{
		id: 25,
		name: 'Lamentations',
		testament: 'OT',
		genre: {
			id: 4,
			name: 'Prophets',
		},
		abbreviations: ['Lam', 'Lam.', 'La'],
	},
	{
		id: 26,
		name: 'Ezekiel',
		testament: 'OT',
		genre: {
			id: 4,
			name: 'Prophets',
		},
		abbreviations: ['Ezek', 'Ezek.', 'Eze', 'Eze.', 'Ezk', 'Ezk.'],
	},
	{
		id: 27,
		name: 'Daniel',
		testament: 'OT',
		genre: {
			id: 4,
			name: 'Prophets',
		},
		abbreviations: ['Dan', 'Dan.', 'Da', 'Dn'],
	},
	{
		id: 28,
		name: 'Hosea',
		testament: 'OT',
		genre: {
			id: 4,
			name: 'Prophets',
		},
		abbreviations: ['Hos', 'Hos.', 'Ho'],
	},
	{
		id: 29,
		name: 'Joel',
		testament: 'OT',
		genre: {
			id: 4,
			name: 'Prophets',
		},
		abbreviations: ['Jl', 'Joe'],
	},
	{
		id: 30,
		name: 'Amos',
		testament: 'OT',
		genre: {
			id: 4,
			name: 'Prophets',
		},
		abbreviations: ['Am', 'Amo', 'Amo.'],
	},
	{
		id: 31,
		name: 'Obadiah',
		testament: 'OT',
		genre: {
			id: 4,
			name: 'Prophets',
		},
		abbreviations: ['Obad', 'Obad.', 'Ob', 'Oba'],
	},
	{
		id: 32,
		name: 'Jonah',
		testament: 'OT',
		genre: {
			id: 4,
			name: 'Prophets',
		},
		abbreviations: ['Jon', 'Jon.', 'Jnh'],
	},
	{
		id: 33,
		name: 'Micah',
		testament: 'OT',
		genre: {
			id: 4,
			name: 'Prophets',
		},
		abbreviations: ['Mic', 'Mic.', 'Mi'],
	},
	{
		id: 34,
		name: 'Nahum',
		testament: 'OT',
		genre: {
			id: 4,
			name: 'Prophets',
		},
		abbreviations: ['Nah', 'Nah.', 'Na'],
	},
	{
		id: 35,
		name: 'Habakkuk',
		testament: 'OT',
		genre: {
			id: 4,
			name: 'Prophets',
		},
		abbreviations: ['Hab', 'Hab.', 'Hb'],
	},
	{
		id: 36,
		name: 'Zephaniah',
		testament: 'OT',
		genre: {
			id: 4,
			name: 'Prophets',
		},
		abbreviations: ['Zeph', 'Zeph.', 'Zep', 'Zep.'],
	},
	{
		id: 37,
		name: 'Haggai',
		testament: 'OT',
		genre: {
			id: 4,
			name: 'Prophets',
		},
		abbreviations: ['Hag', 'Hag.', 'Hg'],
	},
	{
		id: 38,
		name: 'Zechariah',
		testament: 'OT',
		genre: {
			id: 4,
			name: 'Prophets',
		},
		abbreviations: ['Zech', 'Zech.', 'Zec', 'Zec.'],
	},
	{
		id: 39,
		name: 'Malachi',
		testament: 'OT',
		genre: {
			id: 4,
			name: 'Prophets',
		},
		abbreviations: ['Mal', 'Mal.', 'Ml'],
	},
	{
		id: 40,
		name: 'Matthew',
		testament: 'NT',
		genre: {
			id: 5,
			name: 'Gospels',
		},
		abbreviations: ['Matt', 'Matt.', 'Mat', 'Mat.', 'Mt'],
	},
	{
		id: 41,
		name: 'Mark',
		testament: 'NT',
		genre: {
			id: 5,
			name: 'Gospels',
		},
		abbreviations: ['Mk', 'Mrk', 'Mrk.', 'Mr', 'Mr.'],
	},
	{
		id: 42,
		name: 'Luke',
		testament: 'NT',
		genre: {
			id: 5,
			name: 'Gospels',
		},
		abbreviations: ['Lk', 'Lk.', 'Lu', 'Lu.', 'Luk'],
	},
	{
		id: 43,
		name: 'John',
		testament: 'NT',
		genre: {
			id: 5,
			name: 'Gospels',
		},
		abbreviations: ['Jn', 'Jn.', 'Jhn', 'Jhn.'],
	},
	{
		id: 44,
		name: 'Acts',
		testament: 'NT',
		genre: {
			id: 6,
			name: 'Acts',
		},
		abbreviations: ['Act', 'Act.', 'Ac', 'Ac.'],
	},
	{
		id: 45,
		name: 'Romans',
		testament: 'NT',
		genre: {
			id: 7,
			name: 'Epistles',
		},
		abbreviations: ['Rom', 'Rom.', 'Ro', 'Rm'],
	},
	{
		id: 46,
		name: '1 Corinthians',
		testament: 'NT',
		genre: {
			id: 7,
			name: 'Epistles',
		},
		abbreviations: ['1 Cor', '1 Cor.', '1 Co', '1Co', '1Cor', 'I Cor', 'I Cor.', 'I Corinthians'],
	},
	{
		id: 47,
		name: '2 Corinthians',
		testament: 'NT',
		genre: {
			id: 7,
			name: 'Epistles',
		},
		abbreviations: ['2 Cor', '2 Cor.', '2 Co', '2Co', '2Cor', 'II Cor', 'II Cor.', 'II Corinthians'],
	},
	{
		id: 48,
		name: 'Galatians',
		testament: 'NT',
		genre: {
			id: 7,
			name: 'Epistles',
		},
		abbreviations: ['Gal', 'Gal.', 'Ga'],
	},
	{
		id: 49,
		name: 'Ephesians',
		testament: 'NT',
		genre: {
			id: 7,
			name: 'Epistles',
		},
		abbreviations: ['Eph', 'Eph.', 'Ep', 'Ephes', 'Ephes.'],
	},
	{
		id: 50,
		name: 'Philippians',
		testament: 'NT',
		genre: {
			id: 7,
			name: 'Epistles',
		},
		abbreviations: ['Phil', 'Phil.', 'Php', 'Php.', 'Pp'],
	},
	{
		id: 51,
		name: 'Colossians',
		testament: 'NT',
		genre: {
			id: 7,
			name: 'Epistles',
		},
		abbreviations: ['Col', 'Col.', 'Co'],
	},
	{
		id: 52,
		name: '1 Thessalonians',
		testament: 'NT',
		genre: {
			id: 7,
			name: 'Epistles',
		},
		abbreviations: ['1 Thess', '1 Thess.', '1 Thes', '1 Thes.', '1 Th', '1Th', '1Thess', 'I Thess', 'I Thess.', 'I Thessalonians'],
	},
	{
		id: 53,
		name: '2 Thessalonians',
		testament: 'NT',
		genre: {
			id: 7,
			name: 'Epistles',
		},
		abbreviations: ['2 Thess', '2 Thess.', '2 Thes', '2 Thes.', '2 Th', '2Th', '2Thess', 'II Thess', 'II Thess.', 'II Thessalonians'],
	},
	{
		id: 54,
		name: '1 Timothy',
		testament: 'NT',
		genre: {
			id: 7,
			name: 'Epistles',
		},
		abbreviations: ['1 Tim', '1 Tim.', '1 Ti', '1Ti', '1Tim', 'I Tim', 'I Tim.', 'I Timothy'],
	},
	{
		id: 55,
		name: '2 Timothy',
		testament: 'NT',
		genre: {
			id: 7,
			name: 'Epistles',
		},
		abbreviations: ['2 Tim', '2 Tim.', '2 Ti', '2Ti', '2Tim', 'II Tim', 'II Tim.', 'II Timothy'],
	},
	{
		id: 56,
		name: 'Titus',
		testament: 'NT',
		genre: {
			id: 7,
			name: 'Epistles',
		},
		abbreviations: ['Tit', 'Tit.', 'Ti'],
	},
	{
		id: 57,
		name: 'Philemon',
		testament: 'NT',
		genre: {
			id: 7,
			name: 'Epistles',
		},
		abbreviations: ['Phlm', 'Phlm.', 'Phm', 'Phm.', 'Philem', 'Philem.', 'Phile'],
	},
	{
		id: 58,
		name: 'Hebrews',
		testament: 'NT',
		genre: {
			id: 7,
			name: 'Epistles',
		},
		abbreviations: ['Heb', 'Heb.', 'He'],
	},
	{
		id: 59,
		name: 'James',
		testament: 'NT',
		genre: {
			id: 7,
			name: 'Epistles',
		},
		abbreviations: ['Jas', 'Jas.', 'Jam', 'Jam.', 'Jm'],
	},
	{
		id: 60,
		name: '1 Peter',
		testament: 'NT',
		genre: {
			id: 7,
			name: 'Epistles',
		},
		abbreviations: ['1 Pet', '1 Pet.', '1 Pe', '1Pe', '1Pet', '1 Pt', 'I Pet', 'I Pet.', 'I Peter'],
	},
	{
		id: 61,
		name: '2 Peter',
		testament: 'NT',
		genre: {
			id: 7,
			name: 'Epistles',
		},
		abbreviations: ['2 Pet', '2 Pet.', '2 Pe', '2Pe', '2Pet', '2 Pt', 'II Pet', 'II Pet.', 'II Peter'],
	},
	{
		id: 62,
		name: '1 John',
		testament: 'NT',
		genre: {
			id: 7,
			name: 'Epistles',
		},
		abbreviations: ['1 Jn', '1 Jn.', '1 Jo', '1Jo', '1Jn', '1 Jhn', '1 Jhn.', 'I Jn', 'I Jn.', 'I John'],
	},
	{
		id: 63,
		name: '2 John',
		testament: 'NT',
		genre: {
			id: 7,
			name: 'Epistles',
		},
		abbreviations: ['2 Jn', '2 Jn.', '2 Jo', '2Jo', '2Jn', '2 Jhn', '2 Jhn.', 'II Jn', 'II Jn.', 'II John'],
	},
	{
		id: 64,
		name: '3 John',
		testament: 'NT',
		genre: {
			id: 7,
			name: 'Epistles',
		},
		abbreviations: ['3 Jn', '3 Jn.', '3 Jo', '3Jo', '3Jn', '3 Jhn', '3 Jhn.', 'III Jn', 'III Jn.', 'III John'],
	},
	{
		id: 65,
		name: 'Jude',
		testament: 'NT',
		genre: {
			id: 7,
			name: 'Epistles',
		},
		abbreviations: ['Jud', 'Jud.', 'Jd'],
	},
	{
		id: 66,
		name: 'Revelation',
		testament: 'NT',
		genre: {
			id: 8,
			name: 'Apocalyptic',
		},
		abbreviations: ['Rev', 'Rev.', 'Re', 'Rv', 'Rv.', 'Revel', 'Revel.', 'Revelations'],
	},
]
